(function () {
  /* Toggle content */
  $(".product-description-more").click(function (e) {
    e.preventDefault();
    $(this).closest(".product-description-short").next().show();
    $(this).closest(".product-description-short").hide();
  });

  $(".product-description-less").click(function (e) {
    e.preventDefault();
    $(this).closest(".product-description-full").prev().show();
    $(this).closest(".product-description-full").hide();
  });

  /* Toggle fields */
  $(".js-show-more").click(function (e) {
    e.preventDefault();
    $(this).siblings("input").removeClass("hidden");
    $(this).siblings("label").removeClass("hidden");
    $(this).remove();
  });
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
  constructor() {
    super();
    this.renderForm();
  }

  renderForm() {
    fetch(this.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'div[id^="ProductInfo-"]'
        );

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this, this.productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.showMoreFields();
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `floated-${sectionId}`
    );

    if (this.productElement.querySelectorAll("variant-selects")) {
      this.productElement
        .querySelectorAll("variant-selects")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }

    if (this.productElement.querySelectorAll("variant-radios")) {
      this.productElement
        .querySelectorAll("variant-radios")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }
  }

  removeDOMElements() {
    const text = this.productElement.querySelector(".product__text");
    if (text) text.remove();

    const shareButtons = this.productElement.querySelector(".share-buttons");
    if (shareButtons) shareButtons.remove();

    const tags = this.productElement.querySelector(".product-tags");
    if (tags) tags.remove();

    const description = this.productElement.querySelector(
      ".product__description"
    );
    if (description) description.remove();

    const advantage = this.productElement.querySelector(".advantage-wrapper");
    if (advantage) advantage.remove();

    const inventory = this.productElement.querySelector(".advantage");
    if (inventory) inventory.remove();

    const note = this.productElement.querySelector(".note");
    if (note) note.remove();

    const promoBanner = this.productElement.querySelector(".promo-banner");
    if (promoBanner) promoBanner.remove();

    const pickupAvailability = this.productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector("product-modal");
    if (productModal) productModal.remove();

    const productForm = this.productElement.querySelector("floated-form");
    if (productForm) productForm.remove();
    const FloatedFormSticky = this.productElement.querySelector(
      ".product-variant-values"
    );
    if (FloatedFormSticky) FloatedFormSticky.remove();
    const FloatedFormdes = this.productElement.querySelector(
      ".product__description"
    );
    if (FloatedFormdes) FloatedFormdes.remove();
    const FloatedFormabout =
      this.productElement.querySelector(".about__wrapper");
    if (FloatedFormabout) FloatedFormabout.remove();
    const ratingElement = this.productElement.querySelector(".rating");
    const titleWrapper = this.productElement.querySelector(
      ".product__title__wrapper"
    );

    if (ratingElement && titleWrapper) {
      titleWrapper.appendChild(ratingElement);
    }
    const formElement = this.productElement.querySelector(".product-form");
    const priceWrapper = this.productElement.querySelector(".price-wrapper");

    if (formElement && priceWrapper) {
      formElement.appendChild(priceWrapper);
    }
    const relatedProduct = this.productElement.querySelector("related-product");
    if (relatedProduct) relatedProduct.remove();

    const gift = this.productElement.querySelector(".customer");
    if (gift) gift.remove();

    const customLiquid = this.productElement.querySelector(".custom-liquid");
    if (customLiquid) customLiquid.remove();
  }

  showMoreFields() {
    $(".js-show-more").click(function (e) {
      e.preventDefault();
      $(this).siblings("input").removeClass("hidden");
      $(this).siblings("label").removeClass("hidden");
      $(this).remove();
    });
  }
}

customElements.define("floated-form", FloatedForm);

function handleScreenSize() {
  var screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  // Adjust this threshold based on your needs
  var mobileScreenThreshold = 767;

  // Select the element
  var stickyElement = document.querySelector(".Sticky_AddToCart");

  // Check if the screen size is below the threshold
  if (screenWidth <= mobileScreenThreshold) {
    // Remove the element
    if (stickyElement) {
      stickyElement.parentNode.removeChild(stickyElement);
    }
  }
}

// Event listener for continuous monitoring of screen size changes
window.addEventListener("resize", function () {
  // Call the function to handle screen size
  handleScreenSize();

  // Get and log the current screen size
  var currentWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
});

// Initial check
handleScreenSize();

// Prop 65 warning popup
document.addEventListener('DOMContentLoaded', function() {
  // Function to open the popup
  function openPopup() {
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('popup').style.display = 'block';
    document.body.style.overflow = "hidden";
  }

  // Function to close the popup
  function closePopup() {
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('popup').style.display = 'none';
    document.body.style.overflow = "auto";
  }

  // Event listener for the button click
  document.getElementById('AttentionPopupBanner').addEventListener('click', openPopup);

  // Event listener for clicking outside the popup or on the overlay to close it
  window.addEventListener('click', function(event) {
    var popupCloseButton = document.getElementById('closeButton');
    var overlay = document.getElementById('overlay');

    // Check if the clicked element is the close button or one of its descendants
    if (popupCloseButton.contains(event.target)) {
      closePopup();
    } else if (event.target === overlay) {
      closePopup();
    }
  });
  // Event listener for the "Escape" key to close the popup
  window.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closePopup();
    }
  });
});